<claas-breadcrumb
  [productSeriesName]="$safeNavigationMigration(productSeries()?.Name)"
  [productName]="$safeNavigationMigration(product()?.Name)"
></claas-breadcrumb>
<div class="product-detail-headline-container">
  <img
    [src]="
      config.piaAPIOrigin +
        '/' +
        $safeNavigationMigration(productSeries()?.AssetLink) | authImage
    "
    width="100"
    alt=""
    class="product-image"
  />
  <h1 class="product-detail-title font-4xl">{{ productSeries()?.Name }}</h1>
  <button
    (click)="handleFavorites(productSeries()?.ID ?? '')"
    type="button"
    class="favorites-btn icon-only-button"
    [ngClass]="[isFavorite() ? 'blacken' : '']"
  >
    <claas-icon
      [id]="''"
      [iconId]="'649123'"
      [namespace]="'storybook'"
      [iconStyle]="'bold'"
      [size]="24"
      [alt]=""
      [iconName]="'favorites'"
      [removeDefaultColor]="true"
      [class]="'favorites-icon'"
    >
    </claas-icon>
  </button>
</div>

<section class="app-section">
  <claas-product-detail-aside />
  <div class="section-wrapper">
    <router-outlet></router-outlet>
  </div>
</section>
